import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermission';

export default function SmartRedirect() {
  const perms = usePermissions(['clients.access', 'client_portal.access']);

  if (perms['clients.access']) return <Navigate to="/home/clients" replace />;
  if (perms['client_portal.access']) return <Navigate to="/home/client-admin/projects" replace />;

  return <Navigate to="/home/dashboard" replace />;
}
